<div class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast sp-padding__x2">
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__primary sp-padding">BD5</h3>
    </div>
  </div>
  <div
    *ngIf="decido_evaluation"
    class="sp-width__full sp-margin__top-x2 sp-order-details-decido-bd5__grid sp-grid__column-gap-x2 sp-grid__row-gap">
    <app-shared-info-copy
      [label]="'ORDER_DETAILS.ID_DECIDO_LABEL'"
      [content]="decido_evaluation.decido_evaluation_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info-copy
      [label]="'ORDER_DETAILS.PROCESS_ID_LABEL'"
      [content]="decido_evaluation.process_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info
      [label]="'ORDER_DETAILS.RESULT_LABEL'"
      [content]="decido_evaluation.result?.result || '-' | uppercase"
      [content_class]="getEvaluationClass(decido_evaluation.result?.result)"></app-shared-info>
    <app-shared-info
      [label]="'ORDER_DETAILS.CODE_LABEL'"
      [content]="decido_evaluation.result?.code || '-' | uppercase"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'ORDER_DETAILS.RATING_LABEL'"
      [content]="decido_evaluation.result?.rating || '-' | uppercase"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'ORDER_DETAILS.SCORE_LABEL'"
      [content]="decido_evaluation.result?.score || '-' | uppercase"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
  </div>
  <div
    *ngIf="!decido_evaluation && !is_read_running"
    class="sp-width__full sp-margin__top-x12 sp-padding__x4">
    <div class="sp-margin__bottom sp-stroke sp-stroke__dashed-dark sp-width__full"></div>
    <p class="sp-text__center sp-color__primary">{{ 'ORDER_DETAILS.DECIDO_NOT_FOUND_LABEL' | translate }}</p>
    <div class="sp-margin__top sp-stroke sp-stroke__dashed-dark sp-width__full"></div>
  </div>
</div>
